import React, { Fragment, useEffect } from "react";
import { Col, Row } from "reactstrap";
import MediaQuery from "react-responsive";
import { CircularProgress } from "../UI/CircularProgress/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { NotificationCollapse } from "../NotificationsCard/NotificationCollapse/NotificationCollapse";
import { getNotifications, getNotificationsLoading } from "../../reducers/selectors";
import { updateMessage, getMessageAttachment } from "../../services/api/internalMessages";
import { notificationsReload } from "../../actions/entities";
import { getTransactionalPinURL } from "../../services/api/authorizations";
import { setRedirectionData } from "../../utils/handleRedirectionData";
import { showToast } from "../../utils/helper";

import style from "./NotificationsCard.scss";

export const NotificationsCard = () => {
  const notificationsLoading = useSelector(getNotificationsLoading);
  const notifications = useSelector(getNotifications);
  const dispatch = useDispatch();

  let { state } = useLocation();

  useEffect(() => {
    if (state) {
      handleNotificationRead(state.redirectionData);
    }
  }, [state]);

  const handlePreNotificationRead = (notification) => {
    getTransactionalPinURL()
      .then(({ response }) => {
        const pre_pin_validation_token = response.pre_pin_validation_token;
        const redirect_url = response.redirect_url;

        const newRedirectData = {
          id: pre_pin_validation_token,
          data: {
            type: "InternalMessage",
            payload: notification,
          },
        };
        setRedirectionData(newRedirectData);

        window.location.href = redirect_url;
      })
      .catch((err) => {
        console.error(err);
        showToast("Error marcando notificación marcando como leída", true);
      })
      .finally(() => {
        dispatch(notificationsReload());
      });
  };

  const handleNotificationRead = (notification) => {
    updateMessage({ read: true, approved: false, InternalMessageId: notification.InternalMessageId })
      .then(({ response }) => {
        if (response.result.Code === 200) {
          showToast("Notificación marcada como leída correctamente");
        }
      })
      .catch((err) => {
        console.error(err);
        showToast("Error marcando notificación marcando como leída", true);
      })
      .finally(() => {
        dispatch(notificationsReload());
      });
  };

  return (
    <Fragment>
      {notificationsLoading ? (
        <CircularProgress />
      ) : (
        <Row>
          {notifications.map((notification, index) => {
            return (
              <NotificationCollapse
                key={index}
                notification={notification}
                handleNotificationRead={handlePreNotificationRead}
              />
            );
          })}
          {!notifications.length && <EmptyNotifications />}
        </Row>
      )}
    </Fragment>
  );
};

const EmptyNotifications = () => (
  <div className={style.emptyWrapper}>
    <p className={style.emptyMessage}>No hay notificaciones</p>
  </div>
);
